import React from "react";
import PropTypes from "prop-types";
import Constants from "../constants/Constants";

const MediaContent = ({ type, src, alt, controls = true }) => {
  if (!src) {
    return <p className="text-center text-gray-500">No media source provided</p>;
  }

  return (
    <div className="w-full h-full flex items-center justify-center bg-black">
      {type === Constants.VALID_FILE_TYPES.image ? (
        <img
          src={src}
          alt={alt || "Media content"}
          className="max-w-full max-h-full object-contain"
        />
      ) : type === Constants.VALID_FILE_TYPES.video ? (
        <video
          src={src}
          controls={controls}
          className="max-w-full max-h-full object-contain"
        />
      ) : (
        <p className="text-center text-gray-500">Invalid media type</p>
      )}
    </div>
  );
};

MediaContent.propTypes = {
    type: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
    controls: PropTypes.bool,
    };

export default MediaContent;
